"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_profile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile-hi",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 40,
    width: 160,
    height: 112,
    rx: 16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05000000074505806
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.83,104h-56a4,4,0,1,0,0,8h56a4,4,0,1,0,0-8Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05999999865889549
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.83,88h-56a4,4,0,1,0,0,8h56a4,4,0,0,0,0-8Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.83,72h-56a4,4,0,1,0,0,8h56a4,4,0,0,0,0-8Z",
    transform: "translate(0 0)",
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.83,78h56a4,4,0,0,0,3.86-3,4.23,4.23,0,0,1,.14,1,4,4,0,0,1-4,4h-56a4,4,0,0,1-4-4A3.81,3.81,0,0,1,96,75,4,4,0,0,0,99.83,78Z",
    transform: "translate(0 0)",
    style: {
      opacity: 0.05999999865889549,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.83,94h56a4,4,0,0,0,3.86-3,4.23,4.23,0,0,1,.14,1,4,4,0,0,1-4,4h-56a4,4,0,0,1-4-4A3.81,3.81,0,0,1,96,91,4,4,0,0,0,99.83,94Z",
    transform: "translate(0 0)",
    style: {
      opacity: 0.05999999865889549,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.83,110h56a4,4,0,0,0,3.86-3,4.23,4.23,0,0,1,.14,1,4,4,0,0,1-4,4h-56a4,4,0,0,1-4-4,4.23,4.23,0,0,1,.14-1A4,4,0,0,0,99.83,110Z",
    transform: "translate(0 0)",
    style: {
      opacity: 0.05999999865889549,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.27,152a15.89,15.89,0,0,1-7.69-2.38l.05-.25.56-2.77c3.69-18.74,12.55-32.67,24-38.92A26.23,26.23,0,0,1,37,86c0-14.35,11.31-26,25.21-26S87.37,71.67,87.37,86a26.28,26.28,0,0,1-11.18,21.61c11.46,6.24,20.34,20.19,24,39l1,5.15V152h-8Z",
    transform: "translate(0 0)",
    style: {
      opacity: 0.05999999865889549,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.16,62C75.7,62,86.77,73.07,87.34,86.91V86c0-14.35-11.31-26-25.21-26S37,71.67,37,86v.89C37.54,73.07,48.62,62,62.16,62Z",
    transform: "translate(0 0)",
    style: {
      opacity: 0.05999999865889549,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.67,108.51c-.48.39-1,.76-1.48,1.12,11.46,6.24,20.34,20.19,24,39l.68,3.41h.4v-.26l-1-5.15C96.69,128.63,88.41,115.12,77.67,108.51Z",
    transform: "translate(0 0)",
    style: {
      opacity: 0.05999999865889549,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.19,148.58c3.69-18.74,12.55-32.67,24-38.92-.51-.35-1-.73-1.48-1.12-10.71,6.62-19,20.12-22.5,38l-.56,2.77,0,.25.36.21Z",
    transform: "translate(0 0)",
    style: {
      opacity: 0.05999999865889549,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,150H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-2A16,16,0,0,1,160,150Z",
    transform: "translate(0 0)",
    style: {
      opacity: 0.05999999865889549,
      isolation: "isolate"
    }
  })));
}

var _default = ic_profile;
exports.default = _default;